import * as React from 'react';
import styled from 'styled-components';
import Typography from '@mybet/components/Typography';
import Flex from '@mybet/components/Flex';
import getFormattedAmount from '@mybet/core/utils/getFormattedAmount';

const PrizePoolRoot = styled(Flex)((props) => ({
  padding: props.theme.spacing(3, 6),
  margin: props.theme.spacing(3, 1),
  backgroundColor: props.theme.blue14,
  minWidth: '300px',
  maxWidth: '400px',
  flex: 1,
}));

const PoolAmount = styled(Typography)`
  font-size: 42px;
  letter-spacing: 0.27px;
  line-height: 48px;
`;

const Prize = styled(Flex)((props) => ({
  borderBottom: `1px solid ${props.theme.blue13}`,
  width: '100%',
  padding: props.theme.spacing(0.5),

  [Typography]: {
    textTransform: 'none',
  },

  '&:last-of-type': {
    borderBottom: 'none',
  },
}));

type Prize = {
  key: string;
  value: string;
};

type Pool = {
  title: string;
  amount: string;
  prizes: Prize[];
};

type Props = {
  pools: Pool[];
};

export const PrizePool: React.FC<Props> = (props) => {
  const { pools } = props;
  return (
    <Flex fullWidth justifyContent="center" flexWrap="wrap">
      {pools?.map((pool) => (
        <PrizePoolRoot
          key={pool.title}
          flexDirection="column"
          alignItems="center"
        >
          <Typography variant="body2" fontWeight={700}>
            {pool.title}
          </Typography>
          <PoolAmount variant="headline1" gutterTop={1} gutterBottom={2}>
            {getFormattedAmount(+pool.amount, {
              minimumFractionDigits: 0, // note - min needed if setting max for some browsers to avoid out of range error
              maximumFractionDigits: 0,
            })}
          </PoolAmount>
          {pool.prizes?.map((prize) => (
            <Prize
              key={`${prize.key}${prize.value}`}
              justifyContent="space-between"
            >
              <Typography variant="headline3" color="link">
                {prize.key}
              </Typography>
              <Typography variant="headline3" align="right">
                {getFormattedAmount(+prize.value, {
                  minimumFractionDigits: 0, // note - min needed if setting max for some browsers to avoid out of range error
                  maximumFractionDigits: 0,
                })}
              </Typography>
            </Prize>
          ))}
        </PrizePoolRoot>
      ))}
    </Flex>
  );
};

export default PrizePool;
